// eslint-disable-next-line import/no-cycle
import { getUserInfo } from '@/api/user';
import Cookies from 'js-cookie';

const actions = {
  getUserData(context) {
    return new Promise((resolve) => {
      getUserInfo().then((res) => {
        if (!res.success) {
          // 获取用户信息失败
          const id = Cookies.get('user_id');
          context.commit('SET_USER_DATA', { id });
          resolve({ id });
          return;
        }

        const { data } = res;
        const user = {
          id: data.user_id,
          nickname: data.nickname,
          portrait: data.portrait
        };

        context.commit('SET_USER_DATA', user);
        resolve(user);
      });
    });
  }
};

export default actions;
